import { ChangeEventHandler, FC, FocusEventHandler } from 'react';
import RadioButton from '../RadioButton';

type RadioButtonGroupProps = {
  name: string;
  options: { name: string; value: string }[];
  onChange: ChangeEventHandler<HTMLInputElement>;
  onBlur: FocusEventHandler<HTMLInputElement>;
  value: string;
};

const RadioButtonGroup: FC<RadioButtonGroupProps> = (props) => {
  const { name, options, onChange, onBlur, value } = props;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid lightgray',
        borderRadius: '10px',
        overflow: 'hidden',
      }}
    >
      {options.map((option, idx) => (
        <div
          key={option.value}
          style={{
            borderBottom:
              idx === options.length - 1 ? '' : '1px solid lightgray',
          }}
        >
          <RadioButton
            name={name}
            title={option.name}
            value={option.value}
            checked={option.value === value}
            onChange={onChange}
            onBlur={onBlur}
          />
        </div>
      ))}
    </div>
  );
};

export default RadioButtonGroup;
